import { render, staticRenderFns } from "./NHVRBreachesReport.vue?vue&type=template&id=1132f024&scoped=true&"
import script from "./NHVRBreachesReport.vue?vue&type=script&lang=js&"
export * from "./NHVRBreachesReport.vue?vue&type=script&lang=js&"
import style0 from "./NHVRBreachesReport.vue?vue&type=style&index=0&id=1132f024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132f024",
  null
  
)

export default component.exports